// make sure that breakpoints in breakpoints.scss are identical
export const breakpoints: Record<string, number> = {
    phone: 420,
    bigPhone: 570,
    tablet: 832,
    iPad: 1024,
    laptop: 1200,
    desktop: 1392,
    bigDesktop: 1672,
}